<style lang="scss">
@import './table-move.scss';
  
/*平台icon样式*/
.platform-icon-2 {
  color: #bdc5d5;
  font-size: 24px;
  margin: 0 3px;
  line-height: 1.5;
}
</style>
<template>
  <div>
    <div v-show="searchDel" class="table-move-edit">
        <slot name="lefttool"></slot>
        <slot name="righttool"></slot>
        <!-- 渠道授权按钮 -->
        <i-button v-if="queryChannel" class="table-move-edit-del" @click="onStartQuery" ghost-tmp shape="circle" :disabled="selection.length === 0">
            {{ $t('manageChannel.table.channelmanage') }}
        </i-button>
        <!-- 开始计算 -->
        <i-button v-if="showStart" class="table-move-edit-del" @click="onOperate('startCompute')" ghost-tmp shape="circle" :disabled="selection.length === 0">
          {{ $t('manageEvent.table.calculation') }}
        </i-button>
        <!-- 恢复 -->
        <i-button v-if="showRecover" class="table-move-edit-del" @click="onOperate('recover')" ghost-tmp shape="circle" :disabled="selection.length === 0">
          {{ $t('manageEvent.table.recovery') }}
        </i-button>
        <!-- 删除按钮 -->
        <i-button v-if="showDel" class="table-move-edit-del" @click="onOperate('delete')" ghost-tmp shape="circle" :disabled="selection.length === 0">
            <i class="iconfont icon-del"></i>
            {{ $t('manageEvent.table.del') }}
        </i-button>
        <!-- 搜索框 -->
        <slot name="searchSlot"></slot>
        <Input v-if="showSearch" icon="ios-search" :placeholder="$t('filter.search')" style="width: 160px;" v-model="searchFilter" @on-change="filterData"></Input>
        <!-- 下载按钮 -->
        <i v-if="download" class="iconfont icon-download tm-icon-font hover-style tm-icon-font-position" style="margin-left:8px;" @click="exportTable(tableName)"></i>
        <slot name="poptip"></slot>
        <!-- 事件管理的指标说明 -->
        <Poptip trigger="hover" v-if="eventIndexInfo" class="base-view-title-notab-pop" placement="bottom-end">
            <i class="iconfont icon-help tm-icon-font hover-style tm-icon-font-position" style="margin-left:10px;"></i>
            <div slot="title">{{ $t('portrait.indexInfo') }}</div>
            <div slot="content">
                <p><span>{{ $t('manageEvent.tabs.list') }}</span>{{ $t('manageEvent.index.a') }}</p>
                <p class="bg"><span>{{ $t('manageEvent.tabs.recycle') }}</span>{{ $t('manageEvent.index.b') }}</p>
                <p><span>{{ $t('manageEvent.tabs.pending') }}</span>{{ $t('manageEvent.index.c') }}</p>
                <p class="bg"><span>{{ $t('manageEvent.table.displayname') }}</span>{{ $t('manageEvent.index.d') }}</p>
                <p><span>{{ $t('manageEvent.table.registertime') }}</span>{{ $t('manageEvent.index.e') }}</p>
                <p class="bg"><span>{{ $t('manageEvent.table.changetime') }}</span>{{ $t('manageEvent.index.f') }}</p>
                <p><span>{{ $t('manageEvent.table.del') }}</span>{{ $t('manageEvent.index.g') }}</p>
                <p class="bg"><span>{{ $t('manageEvent.table.labellimit') }}</span>{{ $t('manageEvent.index.h') }}</p>

            </div>
        </Poptip>
    </div>
    <div v-if="tableColumns != ''" class="table-move-view">
        <div class="table-move-view-scroll">
          <!-- 表格内容 -->
          <i-table
              :columns="tableColumns"
              :data="tableData"
              :no-data-text="noData"
              ref="table"
              highlight-row
              @on-selection-change="selectionRow"
              @on-sort-change="sortTable"></i-table>
        </div>
        <Row class="table-move-view-page">
            <i-col span="4" v-if="paddingBottom == 140" class="l">
                <i-select v-model="pageSize" style="width:80px;" @on-change="changePage(1)">
                    <i-option v-for="item in pageSizeOpts" :value="item" :key="item">{{item}}{{ $t('version.pagesize') }}</i-option>
                </i-select>
            </i-col>
            <i-col span="20" class="table-move-view-page-box" :style="{ 'padding-bottom': paddingBottom+'px' }">
                <Page :total="pageTotal || changeData.length" :current="cur" @on-change="changePage" :page-size="pageSize" :page-size-opts="pageSizeOpts"></Page>
            </i-col>
        </Row>
    </div>
  </div>
</template>
<script>
import ln from '../../libs/locale';
import bus from '../../libs/bus';
import safeHtml from '../../filters/html-formate';
import editNameMove from '../manage-overview/edit-name-move';
import manageNameMove from '../manage-overview/manage-name-move';
import numberSeparator from '../../filters/number-separator';
import numberToTime from '../../filters/number-to-time';
import sortTableData from '../../filters/sort-table-data';

export default {
  props: {
    searchDel: {
      type: Boolean,
      default: false,
    },
    showDel: {
      type: Boolean,
      default: true,
    },
    showStart: {
      type: Boolean,
      default: false,
    },
    showRecover: {
      type: Boolean,
      default: false,
    },
    queryChannel: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: false,
    },
    tableName: {
      type: String,
      default: 'Table',
    },
    needData: {
      type: Object,
      default() {
        return {};
      },
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    paddingBottom: {
      type: Number / String,
      default: '140',
    },
    eventIndexInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageTotal: 0,
      tableColumns: [],
      saveTableData: '',
      changeData: [],
      tableData: [],
      noData: ln[bus.lang].common.loading,
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      cur: 1,
      nameList: {},
      searchFilter: '', // 搜索
      selection: [], // 已选择项
      // 平台
      platform: {
        1: {
          value: 1,
          name: 'android',
          icon: 'icon-android-r',
        },
        2: {
          value: 2,
          name: 'ios',
          icon: 'icon-iOS-r',
        },
        4: {
          value: 4,
          name: 'windows',
          icon: 'icon-windows-r',
        },
        16: {
          value: 16,
          name: 'html5',
          icon: 'icon-html-r',
        },
        32: {
          value: 32,
          name: 'weichat',
          icon: 'icon-miniprogram-r',
        },
        64: {
          value: 64,
          name: 'quickapp',
          icon: 'icon-kuaiyingyongSDK',
        },
      },
      // 表头数据保存
      saveSetColumn: {
        show: false,
      },
      saveSetColumnData: {
        show: false,
      },
      saveSetChannelColumn: {
        show: false,
      },
      saveSetEventDetails: {
        show: false,
      },
      saveSetAppChannelColumn: {
        show: false,
      },
    };
  },
  components: {
    editNameMove,
    manageNameMove,
  },
  filters: {
    numberSeparator,
    numberToTime,
    sortTableData,
    safeHtml,
  },
  mounted() {
    const self = this;
    bus.$on('on-change-lang', self.changeLang);
  },
  beforeDestroy() {
    this.clearData();
    bus.$off('on-change-lang', this.changeLang);
  },
  methods: {
    changeLang() {
      const self = this;
      if (self.saveSetColumn.show) {
        self.setColumn(self.saveSetColumn.res, self.saveSetColumn.active);
      } else if (self.saveSetColumnData.show) {
        const save = self.saveSetColumnData;
        self.setColumnData(save.str, save.res, save.diff);
      } else if (self.saveSetChannelColumn.show) {
        self.setChannelColumn(self.saveSetChannelColumn.res, self.saveSetChannelColumn.user);
      } else if (self.saveSetEventDetails.show) {
        self.setEventDetails(self.saveSetEventDetails.res);
      } else if (self.saveSetAppChannelColumn.show) {
        const data = self.saveSetAppChannelColumn;
        self.setAppChannelColumn(data.column, data.user, data.mergeChannel);
      }
    },
    /**
     * 接收表头数据
     * @param {[Array]} res    [表头每项的键名list]
     * @param {[String]} active [表格标示]
     */
    setColumn(res, active) {
      this.saveSetColumn = {
        show: true,
        res,
        active,
      };
      const table = {
        columns: [],
      };
      let type = '';
      const name = ln[bus.lang].chartview.table;
      if (active === 'startups') {
        type = 'average';
      } else if (active === 'onetimes') {
        type = 'onetime';
      } else {
        type = active;
      }
      res.forEach((keys) => {
        if (keys === type) {
          table.columns.push({
            title: name[keys],
            key: keys,
            sortable: keys === 'onetime' ? true : 'custom',
            align: 'right',
            className: 'demo-table-info-column',
            render(h, params) {
              return [keys === 'usetime' || keys === 'onetime' ?
                `${params.row[keys] === undefined ? '--' : params.row[keys]}` :
                 `${params.row[keys] === undefined ? '--' : numberSeparator(params.row[keys])}`];
            },
          });
        } else {
          table.columns.push({
            title: name[keys],
            key: keys,
            sortable: keys === 'onetime' ? true : 'custom',
            align: 'right',
            className: '',
            render(h, params) {
              return [keys === 'usetime' || keys === 'onetime' ?
                `${params.row[keys] === undefined || params.row[keys] === '' ? '--' : params.row[keys]}` :
                 `${params.row[keys] === undefined || params.row[keys] === '' ?
                  '--' : numberSeparator(params.row[keys])}`];
            },
          });
        }
      });
      if (active) {
        table.columns.unshift({
          title: ln[bus.lang].keepuser.date,
          key: 'day',
          sortable: true,
          width: 100,
          align: 'left',
        });
      }
      this.tableColumns = table.columns;
    },
    /**
     * 接收channel的表头数据
     * @param {[Array]} column [表头每项的键名list]
     * @param {[String]} user   [表格标示]
     * launchuserAverage指标在3.4.9版本被删除，见bug AA-1699
     * 渠道分析table
     */
    setAppChannelColumn(column, user, mergeChannel) {
      const self = this;
      self.saveSetAppChannelColumn = {
        show: true,
        column,
        user,
        mergeChannel,
      };
      const tableColumns = [];
      const name = ln[bus.lang].channel.tableview[user];
      column.forEach((item) => {
        let sort = 'custom';
        if (item === 'onceuser' || item === 'onetime' ||
            item === 'launchuser' || item === 'launchuserAverage') {
          sort = undefined;
        }
        tableColumns.push({
          title: name[item],
          key: item,
          sortable: sort,
          align: 'right',
          render(h, params) {
            if (params.row[item] === null || params.row[item] === undefined) {
              return ['--'];
            }
            if (item === 'launchuserAverage') {
              return [params.row[item]];
            }
            return [numberSeparator(params.row[item])];
          },
        });
      });
      tableColumns.unshift({
        title: ln[bus.lang].channel.tableview.platform,
        key: 'platform',
        align: 'center',
        render(h, params) {
          if (params.row.platform) {
            return h('i', {
              class: `iconfont ${self.platform[params.row.platform].icon} platform-icon-2`,
            });
          }
          return '';
        },
      });
      tableColumns.unshift({
        title: ln[bus.lang].channel.tableview.name,
        key: 'name',
        render(h, params) {
          const rowName = params.row.name ? safeHtml(params.row.name) : '';
          const partnerid = [params.row.partnerid.toString()];
          if (mergeChannel && mergeChannel.length) {
            mergeChannel.forEach((item) => {
              if (item.partnerid.toString() === partnerid[0]) {
                item.mergedid.forEach((id) => {
                  partnerid.push(id);
                });
              }
            });
          }
          return h('p', {
            class: 'hover-style textEllipsis',
            style: {
              cursor: 'pointer',
            },
            attrs: {
              title: rowName,
            },
            on: {
              click: () => {
                self.channelReturn(partnerid, params.row.name);
              },
            },
          }, rowName);
        },
        align: 'left',
      });
      tableColumns.push({
        title: ln[bus.lang].channel.tableview.set,
        align: 'center',
        render(h, params) {
          const partnerid = [params.row.partnerid.toString()];
          if (mergeChannel && mergeChannel.length) {
            mergeChannel.forEach((item) => {
              if (item.partnerid.toString() === partnerid[0]) {
                item.mergedid.forEach((id) => {
                  partnerid.push(id);
                });
              }
            });
          }
          return h('i', {
            class: 'iconfont icon-Details tm-icon-font tm-icon-font-operation hover-style',
            style: {
              cursor: 'pointer',
            },
            on: {
              click: () => {
                self.channelReturn(partnerid, params.row.name);
              },
            },
          });
        },
      });
      self.tableColumns = tableColumns;
    },
    /**
     * 接收事件管理，label管理的表头数据
     * @param {[String]} str  [表格标示]
     * @param {[Array]} res  [表头每项的键名list]
     * @param {[String]} diff [区分表头的标示]
     */
    setColumnData(str, res, diff) {
      const self = this;
      self.saveSetColumnData = {
        show: true,
        str,
        res,
        diff,
      };
      const table = {
        columns: [],
      };
      const name = ln[bus.lang].manageEvent.table;
      res.forEach((i) => {
        if (i === 'registertime' || i === 'changetime' || i === 'deletetime') {
          table.columns.push({
            title: name[i],
            key: i,
            ellipsis: true,
            render(h, params) {
              const row = params.row;
              if (!row[i]) return ['--'];
              return h('p', {
                class: 'textEllipsis',
                attrs: {
                  title: row[i],
                },
              }, row[i]);
            },
          });
        } else if (i === 'platformid') {
          table.columns.push({
            title: name[i],
            key: i,
            render(h, params) {
              const row = params.row;
              if (!row[i]) return ['--'];
              const innerHTML = [];
              for (let j = 0; j < row.platformid.length; j += 1) {
                innerHTML.push(h('i', {
                  class: `iconfont ${self.platform[row.platformid[j]].icon} platform-icon-2`,
                }));
              }
              return h('span', innerHTML);
            },
          });
        } else if (i === 'labellimit') {
          table.columns.push({
            title: name[i],
            key: i,
            align: 'center',
            width: 80,
            render(h, params) {
              const row = params.row;
              const styleName = row.labellimit === 0 ? '' : 'excess';
              const currentLabel = !row.labellimit ? self.$t('manageEvent.table.normal') :
                self.$t('manageEvent.table.excess');
              return h('span', {
                class: styleName,
              }, currentLabel);
            },
          });
        } else if (i === 'displayname' && str === 'list') {
          table.columns.push({
            title: name[i],
            key: i,
            width: 250,
            render(h, params) {
              const row = params.row;
              // if (!row[i]) return '--';
              return h(editNameMove, {
                props: {
                  name: row.displayname === '' ? '--' : row.displayname,
                  eventid: row.eventid,
                },
                on: {
                  'on-change-edit': self.setSiblingsEdit,
                  'on-change-name-succ': self.updateTableData,
                },
              });
            },
          });
          // 判断是否为灵动事件
          table.columns.unshift({
            width: 30,
            align: 'center',
            renderHeader() {
              return '';
            },
            render(h, params) {
              if (params.row.dynamic === 1) {
                return h('div', [h('i', {
                  class: 'iconfont icon-smart platform-icon-2',
                  style: {
                    color: '#4fe3c1',
                  },
                })]);
              }
              return '';
            },
          });
        } else if (i === 'eventid') {
          table.columns.push({
            title: name[i],
            key: i,
            ellipsis: true,
            render(h, params) {
              const row = params.row;
              if (!row[i]) return ['--'];
              return h('p', {
                class: 'textEllipsis',
                attrs: {
                  title: row.eventid,
                },
              }, row.eventid);
            },
          });
        } else {
          table.columns.push({
            title: name[i],
            key: i,
            render(h, params) {
              const row = params.row;
              let temp = '';
              // eventlabel是一个对象时，需要转成字符串
              if (row[i] instanceof Object) {
                temp = JSON.stringify(row[i]);
              } else {
                temp = row[i];
              }
              if (!row[i]) return ['--'];
              return h('p', {
                class: 'textEllipsis',
                attrs: {
                  title: temp,
                },
              }, temp);
            },
          });
        }
      });

      table.columns.unshift({
        type: 'selection',
        width: 40,
        align: 'center',
      });
      if (str === 'list') {
        table.columns.push({
          title: name.operation,
          key: 'action',
          width: 100,
          align: 'center',
          render(h, params) {
            const row = params.row;
            return h('a', {
              on: {
                click: () => {
                  self.returnName(row.eventid, row.index, row.displayname);
                },
              },
            }, name.labelmanage);
          },
        });
      }
      if (str === 'pending') {
        table.columns.push({
          title: name.operation,
          key: 'action',
          width: 100,
          align: 'center',
          render(h, params) {
            const row = params.row;
            if (!row.eventid) return '--';
            // const pendingInfo = diff === 'event' ? row.eventid : row.eventlabel;
            return h('a', {
              on: {
                click() {
                  self.modalAlert('pending', [row]); // 需要知道当前事件的平台
                },
              },
            }, name.calculation);
          },
        });
      }
      if (str === 'recycle') {
        table.columns.push({
          title: name.operation,
          key: 'action',
          width: 100,
          align: 'center',
          render(h, params) {
            const row = params.row;
            // const recycleInfo = diff === 'event' ? row.eventid : row.eventlabel;
            return h('a', {
              on: {
                click() {
                  self.modalAlert('recycle', [row]);
                },
              },
            }, name.recovery);
          },
        });
      }
      self.tableColumns = table.columns;
    },
    /**
     * 接收manageChannel表头数据
     * @param {[Array]} res  [表头每项的键名list]
     * @param {[String]} user [表格标示]
     */
    setChannelColumn(res, user) {
      const self = this;
      self.saveSetChannelColumn = {
        show: true,
        res,
        user,
      };
      const table = {
        columns: [],
      };
      const name = ln[bus.lang][user].table;
      res.forEach((keys) => {
        if (keys === 'platformid') {
          table.columns.push({
            title: name[keys],
            key: keys,
            ellipsis: true,
            renderHeader(h) {
              return h('p', {
                class: 'textEllipsis',
              }, name[keys]);
            },
            render(h, params) {
              return h('i', {
                class: `iconfont ${self.platform[params.row.platformid].icon} platform-icon-2`,
              });
            },
          });
        } else if (keys === 'registertime') {
          table.columns.push({
            title: name[keys],
            key: keys,
            sortable: true,
            ellipsis: true,
          });
        } else if (keys === 'displayname') {
          table.columns.push({
            title: name[keys],
            key: keys,
            width: 220,
            render(h, params) {
              const row = params.row;
              const displayName = row.displayname ? row.displayname : '--';
              return h(manageNameMove, {
                props: {
                  name: displayName,
                  partnerid: row.partnerid.toString(),
                },
                on: {
                  'on-change-channel-edit': self.setSiblingsEdit,
                  'on-change-name-succ': self.updateChannelTableData,
                },
              });
            },
          });
        } else if (keys === 'isdisplay') {
          table.columns.push({
            title: name[keys],
            key: keys,
            align: 'left',
            renderHeader(h) {
              return h('p', {
                class: 'textEllipsis',
              }, name[keys]);
            },
            render(h, params) {
              const row = params.row;
              return h('i-switch', {
                props: {
                  size: 'large',
                  value: row.isdisplay,
                },
                on: {
                  'on-change': () => {
                    self.changeState(row.partnerid, row.isdisplay);
                  },
                },
              }, [h('span', {
                slot: 'open',
              }, name.show), h('span', {
                slot: 'close',
              }, name.hide)]);
            },
          });
        } else if (keys === 'channelstr') {
          table.columns.push({
            title: name[keys],
            key: keys,
            align: 'left',
            render(h, params) {
              const row = params.row;
              const split = !(row.channelstr === '');
              return h('div', [h('a', {
                domProps: {
                  title: name.mergeinfo,
                },
                on: {
                  click() {
                    self.startMerge(row.partnerid);
                  },
                },
              }, `${name.merge} `), h('a', {
                domProps: {
                  title: name.splitinfo,
                },
                style: {
                  display: split ? 'inline-block' : 'none',
                },
                on: {
                  click() {
                    self.startSplit(row.partnerid, row.channelstr);
                  },
                },
              }, ` | ${name.split}`)]);
            },
//            render(row) {
//              const split = !(row.channelstr === '');
//              return `<div v-show="${split}">
//                      <a
//                      title="${name.mergeinfo}"
//                      @click="startMerge(${row.partnerid})">${name.merge}</a> |
//                      <a
//                      title="${name.splitinfo}"
//                      @click="startSplit(${row.partnerid},'${row.channelstr}')">
//                      ${name.split}</a></div>
//                    <a
//                    v-else
//                    title="${name.mergeinfo}"
//                    @click="startMerge(${row.partnerid})">${name.merge}</a>`;
//            },
          });
        } else if (keys === 'partnername') {
          table.columns.push({
            title: name[keys],
            key: keys,
            render(h, params) {
              const row = params.row;
              return h('p', {
                props: {
                  class: 'textEllipsis',
                  title: safeHtml(row.partnername),
                },
              }, safeHtml(row.partnername));
            },
          });
        } else {
          table.columns.push({
            title: name[keys],
            key: keys,
          });
        }
      });

      table.columns.unshift({
        type: 'selection',
        width: 40,
        align: 'center',
      });
      self.tableColumns = table.columns;
    },
    /**
     * 接收事件详情表头数据
     * @param {[Array]} res  [表头每项的键名list]
     * @param {[String]} type [高亮列的键名]
     */
    setEventDetails(res, type) {
      this.saveSetEventDetails = {
        show: true,
        res,
      };
      const table = {
        columns: [],
      };
      const name = ln[bus.lang].eventdetails;
      res.forEach((keys) => {
        if (keys === 'happen' || keys === 'startup') {
          const rateFlag = keys === 'happen' ? '%' : '';
          table.columns.push({
            title: name[keys],
            key: keys,
            sortable: 'custom',
            align: 'right',
            className: keys === type ? 'demo-table-info-column' : '',
            render(h, params) {
              const row = params.row;
              return [row[keys] === undefined ? '--' : `${numberSeparator(row[keys])}${rateFlag}`];
            },
          });
        } else {
          table.columns.push({
            title: name[keys],
            key: keys,
            align: 'right',
            sortable: 'custom',
            className: keys === type ? 'demo-table-info-column' : '',
            render(h, params) {
              const row = params.row;
              return [row[keys] === undefined ? '--' : numberSeparator(row[keys])];
            },
          });
        }
      });
      table.columns.unshift({
        title: name.day,
        key: 'day',
        sortable: true,
        width: 100,
        align: 'left',
      });
      this.tableColumns = table.columns;
    },
    // 接收全部分页内容
    setAllData(res) {
      const table = {
        data: [],
      };
      Object.keys(res).forEach((k) => {
        for (let i = 0; i < res[k].length; i += 1) {
          const item = res[k][i][k];
          if (table.data[i] === undefined) {
            table.data[i] = res[k][i];
          } else {
            table.data[i][k] = k === 'onetime' ? numberToTime(item) : item;
          }
        }
      });
      this.changeData = table.data;
      this.saveTableData = JSON.stringify(table.data);
      this.tableData = this.mockTableData(1, this.changeData);
    },
    // 接收分页内容数据
    setTableData(keys, res) {
      const table = {
        data: [],
      };
      for (let i = 0; i < res.length; i += 1) {
        Object.keys(keys).forEach((k) => {
          const item = res[i][k];
          if (table.data[i] === undefined) {
            table.data[i] = res[i];
          } else {
            // eslint-disable-next-line
            if (item === undefined) {
              table.data[i][k] = '';
            } else {
              // eslint-disable-next-line
              if (k === 'onetime') {
                table.data[i][k] = numberToTime(item);
              } else {
                table.data[i][k] = item;
              }
            }
          }
        });
      }
      this.saveTableData = JSON.stringify(table.data);
      this.changeData = table.data;
      this.tableData = this.mockTableData(1, this.changeData);
    },
    // 接收事件管理，label管理的内容数据
    setManageData(data, str) {
      const table = {
        data,
      };
      // const name = ln[bus.lang].manageEvent.table;
      for (let key = 0, l = table.data.length; key < l; key += 1) {
        if (table.data[key] !== {}) {
          table.data[key].displayname = table.data[key].displayname === undefined ?
            table.data[key].eventid : table.data[key].displayname;
        }
      }
      if (typeof str === 'number') {
        const cur = str === 0 ? 1 : this.cur;
        this.saveTableData = JSON.stringify(table.data);
        this.pageTotal = str;
        this.changeData = table.data;
        this.tableData = this.mockTableData(cur, table.data);
      } else {
        this.saveTableData = JSON.stringify(table.data);
        this.changeData = table.data;
        this.tableData = this.mockTableData(1, this.changeData);
      }
    },
    // 接收manageChannel内容数据
    setChannelData(res) {
      const table = {
        data: res,
      };
      this.saveTableData = JSON.stringify(table.data);
      this.changeData = table.data;
      this.tableData = this.mockTableData(1, this.changeData);
    },
    /**
     * 切换图表对应表格列高亮
     * @param  {[String]} str [高亮列的对应 key]
     */
    changeColumnColor(str) {
      let arg = str;
      if (str === 'startups') arg = 'average';
      if (str === 'onetimes') arg = 'onetime';
      Object.keys(this.tableColumns).forEach((item) => {
        if (this.tableColumns[item].key === arg) {
          this.tableColumns[item].className = 'demo-table-info-column';
        } else {
          this.tableColumns[item].className = '';
        }
      });
    },
    /**
     * 数据处理分页
     * @param  {[Number]} ind  [对应显示的页码]
     * @param  {[Array]} data [要分页的数据]
     */
    mockTableData(ind, data) {
      const self = this;
      let i = ind ? self.pageSize * (ind - 1) : 0;
      let len = i + self.pageSize;
      const show = [];
      self.cur = ind;
      if (data) {
        len = len < data.length ? len : data.length;
        for (i; i < len; i += 1) {
          show.push(data[i]);
        }
      }
      if (show.length === 0) self.noData = ln[bus.lang].common.nodata;
      return show;
    },
    /**
     * 数据趋势表格数据处理
     * @param {[Number]} i   [数据 index]
     * @param {[String]} day [数据日期时间]
     * @param {[String]} res [数据对应的 键值]
     * @param {[String]} str [数据对应的 键名]
     */
    setData(i, day, res, str) {
      for (let k = 0; k < this.changeData.length; k += 1) {
        if (day === this.changeData[k].day) {
          this.changeData[k][str] = res;
          this.saveTableData = JSON.stringify(this.changeData);
          this.tableData = this.mockTableData(this.cur, this.changeData);
        }
      }
    },
    /**
     * 页码切换
     * @param  {[Number]} index [切换的页码数]
     */
    changePage(index) {
      this.tableData = this.mockTableData(index, this.changeData);
      this.$emit('on-change-page', index, this.pageSize);
    },
    /**
     * 渠道分析搜索后数据处理
     * @param {[String]} str  [搜索的字段]
     * @param {[String]} flag [搜索的表格标识]
     */
    setSearchData(str, flag) {
      const self = this;
      const newData = JSON.parse(this.saveTableData);
      if (str === '') {
        self.changeData = newData;
      } else {
        for (let i = 0; i < newData.length; i += 1) {
          const index = newData[i].name.toLowerCase().indexOf(str.toLowerCase());
          if (index === -1) {
            newData.splice(i, 1);
            i -= 1;
          }
        }
        self.changeData = newData;
      }
      if (flag !== 'number') {
        self.changePage(1, flag);
      } else {
        this.tableData = this.mockTableData(1, this.changeData);
      }
    },
    // 清空数据
    clearData() {
      this.pageTotal = 0;
      this.nameList = {};
      this.changeData = [];
      this.saveTableData = '';
      this.searchFilter = '';
      this.tableData = [];
      this.tableColumns = [];
      this.cur = 1;
      this.pageSize = 10;
      this.noData = ln[bus.lang].common.loading;
      this.selection = [];
      this.saveSetColumn = {
        show: false,
      };
      this.saveSetColumnData = {
        show: false,
      };
      this.saveSetChannelColumn = {
        show: false,
      };
      this.saveSetEventDetails = {
        show: false,
      };
      this.saveSetAppChannelColumn = {
        show: false,
      };
    },
    /**
     * 导出表格原始数据
     * @param  {[String]} str [表格名称标示]
     */
    exportTable(str) {
      const name = str || this.tableName;
      let data = [];
      if (typeof this.saveTableData === 'object') { // 数组
        data = this.saveTableData;
      } else { // 字符串
        data = JSON.parse(this.saveTableData);
      }
      const returnData = data.map((val) => {
        const a = {};
        Object.keys(val).forEach((i) => {
          if (i === 'platform' || i === 'platformid') {
            a[i] = typeof val[i] === 'number' ?
              this.platform[val[i]].name : val[i].map(k => this.platform[k].name).join('，');
          } else {
            a[i] = typeof val[i] === 'string' && val[i].indexOf(',') > -1 ?
              val[i].split(',').join('') : a[i] = val[i];
          }
        });
        return a;
      });
      const filename = bus.getDownloadName(name);
      const tableColumn = this.tableColumns.filter(col => col.key !== 'set');
      if (this.$refs.table) {
        this.$refs.table.exportCsv({
          filename,
          columns: tableColumn,
          data: returnData,
        });
      }
    },
    // 删除、批量恢复、批量开始计算操作
    onOperate(msg) {
      /*
      ** demo环境下不允许增删改
      **/
      if (bus.demoTip()) return;

      if (this.selection.length !== 0) {
        if (msg === 'delete') {
          this.$emit('on-del-manage-event', this.selection);
        } else if (msg === 'startCompute') {
          this.$emit('on-alert-info', 'pending', this.selection);
        } else if (msg === 'recover') {
          this.$emit('on-alert-info', 'recycle', this.selection);
        }
      }
    },
    /**
     * 选择行数据操作
     * @param  {[Array]} array [选择的行数据数组]
     */
    selectionRow(array) {
      this.selection = array;
    },
    // 搜索
    filterData() {
      const self = this;
      const data = self.saveTableData ? JSON.parse(self.saveTableData) : [];
      const search = this.searchFilter.toLowerCase();
      if (self.selection.length > 0) self.selection = [];
      if (data.length === 0) return;
      if (search === '') {
        self.changeData = data;
      } else {
        for (let i = 0; i < data.length; i += 1) {
          if (data[i].eventid) {
            if (data[i].eventlabel) {
              const searchNumber = data[i].eventlabel.toLowerCase().indexOf(search);
              if (searchNumber === -1) {
                data.splice(i, 1);
                i -= 1;
              }
            } else if (data[i].displayname) {
              const searchNamedata = data[i].displayname.toLowerCase().indexOf(search);
              if (data[i].eventid.toLowerCase().indexOf(search) === -1 && searchNamedata === -1) {
                data.splice(i, 1);
                i -= 1;
              }
            } else if (data[i].eventname) {
              const searchNamedata = data[i].eventname.toLowerCase().indexOf(search);
              if (data[i].eventid.toLowerCase().indexOf(search) === -1 && searchNamedata === -1) {
                data.splice(i, 1);
                i -= 1;
              }
            } else {
              // eslint-disable-next-line
              if (data[i].eventid.toLowerCase().indexOf(search) === -1) {
                data.splice(i, 1);
                i -= 1;
              }
            }
          } else if (data[i].partnername) {
            const partneridNumber = data[i].partnername.toString().toLowerCase().indexOf(search);
            const partnernameNumber = data[i].displayname ?
              data[i].displayname.toLowerCase().indexOf(search) : -1;
            if (partneridNumber === -1 && partnernameNumber === -1) {
              data.splice(i, 1);
              i -= 1;
            }
          } else if (data[i].name) {
            const nameNumber = data[i].name.toString().toLowerCase().indexOf(search);
            if (nameNumber === -1) {
              data.splice(i, 1);
              i -= 1;
            }
          } else if (data[i].eventvalue) {
            const eventvalue = data[i].eventvalue.toString().toLowerCase().indexOf(search);
            if (eventvalue === -1) {
              data.splice(i, 1);
              i -= 1;
            }
          } else if (data[i].options) {
            const options = data[i].options.toString().toLowerCase().indexOf(search);
            if (options === -1) {
              data.splice(i, 1);
              i -= 1;
            }
          }
        }
        self.changeData = data;
      }
      self.changePage(1);
      self.$emit('on-filter-data', 'filter');
    },
    /**
     * 事件管理表单操作弹框提示
     * @param  {[String]} modalInfo [弹窗标示]
     * @param  {[String]} string    [操作行对应的事件ID或 labelID]
     */
    modalAlert(modalInfo, string) {
      this.$emit('on-alert-info', modalInfo, string);
    },
    // 跳转Label页面
    returnName(id, ind, name) {
      const manageLabelInfo = {
        manageLabelIndex: ind,
        manageLabelId: id,
        manageLabelName: name,
      };
      try {
        sessionStorage.setItem('manageLabelInfo', JSON.stringify(manageLabelInfo));
      } catch (e) {
        bus.sessionStorage.manageLabelInfo = JSON.stringify(manageLabelInfo);
      }
      this.$router.push({
        name: 'manageLabel',
        params: {
          managelabelName: encodeURIComponent(name) || encodeURIComponent(id),
        },
      });
    },
    // 跳转事件详情页
    detailsPage(index) {
      const saveData = JSON.parse(this.saveTableData);
      const item = saveData.filter(v => v.index * 1 === index * 1);
      const eventAnalysis = {
        eventid: item[0].id,
        eventname: item[0].eventname,
        eventtype: item[0].eventType,
      };
      try {
        sessionStorage.setItem('eventAnalysis', JSON.stringify(eventAnalysis));
      } catch (e) {
        bus.sessionStorage.eventAnalysis = JSON.stringify(eventAnalysis);
      }
      this.$router.push({
        name: 'eventAnalysis',
        params: {
          eventname: encodeURIComponent(item[0].eventname),
        },
      });
    },
    /**
     * 跳转渠道分析页面传递id,name
     * @param  {[String]} id   [渠道ID]
     * @param  {[String]} name [渠道名称]
     */
    channelReturn(id, name) {
      const channelInfo = {
        channelId: id,
        channelName: name,
      };
      // 对不支持sessionStorage的浏览器，存在bus.sessionStorage里
      try {
        sessionStorage.setItem('channelInfo', JSON.stringify(channelInfo));
      } catch (e) {
        bus.sessionStorage.channelInfo = JSON.stringify(channelInfo);
      }
      this.$router.push({
        name: 'channelDetail',
        params: {
          channelName: encodeURIComponent(name),
        },
      });
    },
    /**
     * 跳转编辑转化漏斗页面
     * @param  {[String]} name [点击行的转换漏斗名称]
     * @param  {[Number]} ind  [点击行的 index]
     */
    returnSetFunnel(name, ind) {
      const index = ((this.cur - 1) * this.pageSize) + ind;
      bus.setFunnel = this.changeData[index];
      this.$router.push({
        name: 'setfunnel',
        params: {
          funnelname: encodeURIComponent(name),
        },
      });
    },
    /**
     * 跳转转化漏斗详情页面
     * @param  {[String]} name [点击行的转换漏斗名称]
     * @param  {[Number]} ind  [点击行的 index]
     */
    returnFunnelChart(name, ind) {
      const index = ((this.cur - 1) * this.pageSize) + ind;
      bus.funnelChart = this.changeData[index];
      this.$router.push({
        name: 'funnelchart',
        params: {
          funnelname: encodeURIComponent(name),
        },
      });
    },
    /**
     * 执行删除table数据操作
     * @param  {[Array / String]} ids  [所要删除的内容]
     * @param  {[String]} type [删除内容的对应 key]
     */
    removeData(ids, type) {
      const set = typeof ids === 'string';
      for (let i = 0; i < this.changeData.length; i += 1) {
        if (set) {
          if (ids === this.changeData[i][type]) {
            this.changeData.splice(i, 1);
          }
        } else {
          this.changeData = this.changeData.filter(x => ids.indexOf(x[type]) === -1);
        }
      }
      let savedata = JSON.parse(this.saveTableData);
      for (let i = 0; i < savedata.length; i += 1) {
        if (set) {
          if (ids === savedata[i][type]) {
            savedata.splice(i, 1);
          }
        } else {
          savedata = savedata.filter(x => ids.indexOf(x[type]) === -1);
        }
      }
      this.saveTableData = savedata.length === 0 ? '' : JSON.stringify(savedata);
      this.selection = [];
      this.tableData = this.mockTableData(this.cur, this.changeData);
    },
    /**
     * 关闭其他行的编辑名称
     * @param {[String]} id [对应行的渠道ID]
     */
    setSiblingsEdit(id) {
      for (let i = 0; i < this.tableData.length; i += 1) {
        bus.$emit('on-close-edit', id);
      }
    },
    /**
     * switch按钮切换
     * @param  {[String]} id   [渠道ID]
     * @param  {[Number]} type [切换的状态 0为显示 1为隐藏]
     */
    changeState(id, type) {
      this.$emit('on-change-type', id, type);
    },
    // 渠道授权按钮事件
    onStartQuery() {
      if (this.selection.length !== 0) {
        this.$emit('on-query-channel-event', this.selection);
      }
    },
    /**
     * 合并渠道
     * @param  {[String]} id [对应渠道ID]
     */
    startMerge(id) {
      this.$emit('on-merge-channel', id);
    },
    /**
     * 拆分渠道
     * @param  {[String]} id  [渠道ID]
     * @param  {[String]} str [被合并渠道的 ID字符串]
     */
    startSplit(id, str) {
      this.$emit('on-split-channel', id, str);
    },
    // 显示Label下参数的模态框
    showLabelModal(val, type, num) {
      if (type === 'modallabel') {
        bus.$emit('on-modal-option-label', val, type, this.tableName, this.needData);
      }
      if (type === 'modaloption') {
        bus.$emit('on-modal-option-label', val, type, this.tableName, num);
      }
    },
    /**
     * 自定义排序
     * @param  {[Object]} obj [点击排序列内容]
     */
    sortTable(obj) {
      const data = this.changeData;
      const list = sortTableData(obj, data);
      this.changeData = list;
      this.tableData = this.mockTableData(1, this.changeData);
      this.$emit('on-set-sort-data', obj.order);
    },
    /** 更改事件名称回调成功后更新tableData
     * @param {id} [String] eventid 标识二维码唯一id
     * @param {name} [String] 修改后的事件名称
     */
    updateTableData(id, name) {
      this.tableData.forEach((v, i) => {
        if (v.eventid === id) this.tableData[i].displayname = name;
      });
    },
    updateChannelTableData(id, name) {
      const self = this;
      self.tableData.forEach((v, i) => {
        if (v.partnerid.toString() === id) {
          self.tableData[i].displayname = name;
        }
      });
    },
  },
};
</script>
